// ----------------------------------------------------------------------

const MuiAppBar = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { color: 'transparent' },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { root: { boxShadow: 'none' } }
}

// ----------------------------------------------------------------------

export const appBar = { MuiAppBar }
